import React from 'react';

const QuestionMarkIcon = () => {
  return (
    <svg
      className="SvgUI-sc-1hby79s-0 fXgkWF"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="svg-title"
      aria-describedby="svg-desc"
      width="20"
      height="15"
      style={{
        fill: 'rgb(102, 102, 102)'
      }}
    >
      <svg id="icon-attendance-doubt" viewBox="0 0 28 28" width="100%" height="100%">
        <path
          fill="inherit"
          d="M14 0C6.269 0 0 6.267 0 14c0 7.73 6.269 14 14 14 7.732 0 14-6.27 14-14 0-7.733-6.268-14-14-14m1.312 20.999h-2.645v-2.644h2.645v2.644m3.092-8.319c-.329.521-1.034 1.23-2.113 2.126-.559.465-.904.838-1.04 1.121-.135.282-.196.787-.183 1.514h-2.4c-.007-.344-.01-.555-.01-.631 0-.776.129-1.416.386-1.918s.771-1.067 1.544-1.694c.771-.628 1.232-1.038 1.383-1.233.232-.307.348-.646.348-1.016 0-.514-.205-.956-.615-1.322-.411-.367-.965-.551-1.662-.551-.671 0-1.232.191-1.684.574-.452.383-.762.966-.932 1.75l-2.428-.3c.069-1.123.548-2.078 1.435-2.862.888-.784 2.054-1.177 3.497-1.177 1.518 0 2.725.398 3.623 1.192.898.793 1.347 1.717 1.347 2.771a3.077 3.077 0 0 1-.496 1.656"
        />
      </svg>
    </svg>
  );
};

export default QuestionMarkIcon;
